import axios from 'axios';

import type { CountryWithCultures } from '@apple/utils/globalization/models';
import { countryWithCulturesSchema } from '@apple/utils/globalization/models';

import type { Country } from './models';
import { countrySchema } from './models';

/** AppleBrandedPrograms.Web.Areas.Admin.ApiControllers.CountryAdminApiController */
export async function getCountry(countryCode: string): Promise<Country> {
	const response = await axios.get<unknown>(`/api/management/supported-countries/${countryCode}`);

	return countrySchema.parse(response.data);
}

/** AppleBrandedPrograms.Web.Areas.Admin.ApiControllers.CountryAdminApiController */
export async function getCountries(): Promise<CountryWithCultures[]> {
	const response = await axios.get<unknown>('/api/management/supported-countries/available');

	return countryWithCulturesSchema.array().parse(response.data);
}

/** AppleBrandedPrograms.Web.Areas.Admin.ApiControllers.CountryAdminApiController */
export async function saveCountry(country: Country): Promise<void> {
	await axios.put(`/api/management/supported-countries/${country.code}`, {
		...country,
		plant: country.plant
			? {
					...country.plant,
					warehouseLocationId: country.plant.warehouseLocationId.toString(),
				}
			: country.plant,
	});
}

/** AppleBrandedPrograms.Web.Areas.Admin.ApiControllers.CountryAdminApiController */
export async function deleteCountry(countryCode: string): Promise<void> {
	await axios.delete(`/api/management/supported-countries/${countryCode}`);
}
